export default __webpack_public_path__ + "static/build_uk_web-f56bdb4473186fd0eefeabea2e5fae0b.webp";